import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll px-3 flex flex-col space-y-3"
};
const _hoisted_3 = { class: "flex flex-col space-y-3" };
const _hoisted_4 = { class: "text-md font-normal text-gray-900" };
const _hoisted_5 = {
    class: "flex flex-wrap px-2",
    style: { "column-gap": "19px", "row-gap": "11px" }
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    class: "flex flex-col rounded-lg space-x-2 items-center justify-center",
    style: { "width": "67px", "height": "67px" }
};
const _hoisted_8 = { class: "text-xs font-normal text-gray-700" };
import { cropOptions } from '@/compositions/useCropOptions';
import { UIDivider } from '@gohighlevel/ghl-ui';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CropTool',
    props: {
        cropper: {
            type: Object,
            require: true,
        },
        width: {
            type: Number,
            require: true,
        },
        height: {
            type: Number,
            require: true,
        },
        canvasCtx: {
            type: Object,
            require: true,
        },
        bgImage: {
            type: Object,
            require: true,
        },
    },
    emits: ['changeAspectRatio'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const bgWidth = computed(() => { var _a; return (_a = props.width) === null || _a === void 0 ? void 0 : _a.toString(); });
        const bgHeight = computed(() => { var _a; return (_a = props.height) === null || _a === void 0 ? void 0 : _a.toString(); });
        const widthInput = ref(bgWidth.value);
        const heightInput = ref(bgHeight.value);
        const zoomValue = ref(100);
        const cropStyle = ref('custom');
        watch(bgWidth, () => {
            var _a;
            widthInput.value = (_a = props.width) === null || _a === void 0 ? void 0 : _a.toString();
        });
        watch(bgHeight, () => {
            var _a;
            heightInput.value = (_a = props.height) === null || _a === void 0 ? void 0 : _a.toString();
        });
        function setCropFrame(option) {
            cropStyle.value = option.value;
            emits('changeAspectRatio', option.aspectRatio);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('crop.title')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cropOptions), (cropType) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: cropType.value,
                                class: "flex flex-col space-y-2"
                            }, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(cropType.title)), 1),
                                _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cropType.options, (option) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: option.title,
                                            style: { "height": "120px", "width": "100px" },
                                            class: _normalizeClass(["flex flex-col items-center space-y-2 cursor-pointer justify-center rounded-lg border",
                                                option.value == cropStyle.value ? 'border-primary' : 'border-gray-300'
                                            ]),
                                            onClick: ($event) => (setCropFrame(option))
                                        }, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["p-2 flex flex-col items-center justify-center text-gray-900 font-bold text-xs rounded-lg", option.classes]),
                                                    style: _normalizeStyle(option.styles)
                                                }, _toDisplayString(option.placeholder), 7)
                                            ]),
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(option.title)), 1)
                                        ], 10, _hoisted_6));
                                    }), 128))
                                ]),
                                _createVNode(_unref(UIDivider))
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
